export default function getInitialState() {
  return {
    products: [],
    sharedProducts: [],
    isLoading: false,
    credentials: {},
    categories: [],
    banners: [],
    alarmProducts: {},
    isIframe: false,
    iframeProducts: [],
    iframeParentUrl: ''
  };
}
